/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EmployeeLink } from 'domain/shared/employee';
import { TextField } from 'framework/ui/field';
import { EntityHeader } from 'framework/ui/layout';

const ContractsHeader = () => {
  return (
    <EntityHeader
      entityTitleSource="employeeName"
      hasAuthor={false}
      defaultAuthor={DEFAULT_ENTITY_AUTHOR}
      entityTitle={data => (
        <EmployeeLink id={data.getValueBySource('employeeAlias')} name={data.getValueBySource('employeeName')} />
      )}
    >
      <TextField metaInformation label="Worker ID:" source="employeeAlias" />
    </EntityHeader>
  );
};

export default ContractsHeader;
